import { Component } from '@theme/component';

class EmePasswordField extends Component {
  requiredRefs = ['input', 'toggle'];

  #form = null;

  connectedCallback() {
    super.connectedCallback();
    this.refs.toggle.hidden = false;
    this.#form = this.refs.input.form;
    this.#form?.addEventListener('submit', this.#conceal);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#form?.removeEventListener('submit', this.#conceal);
    this.#form = null;
  }

  toggle() {
    const { input, toggle } = this.refs;
    const reveal = input.type === 'password';
    input.type = reveal ? 'text' : 'password';
    toggle.setAttribute('aria-pressed', String(reveal));
    input.focus();
  }

  #conceal = () => {
    const { input, toggle } = this.refs;
    input.type = 'password';
    toggle.setAttribute('aria-pressed', 'false');
  };
}

if (!customElements.get('eme-password-field')) customElements.define('eme-password-field', EmePasswordField);
